import CheckmateApiClient from '../../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();


const useGetSameCaseEasyUpdateKey = 'get-same-case-easy-update';

export const useGetSameCaseEasyUpdate = (sameCaseGuid: string | undefined) => {
    return useQuery({
        queryKey: [useGetSameCaseEasyUpdateKey, sameCaseGuid],
        queryFn: async () => {
            if (!sameCaseGuid) {
                return;
            }

            const response = await _apiClient.getSameCaseEasyUpdate(sameCaseGuid);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the cases for this same case.');
            }

            return response.payload;
        },
        enabled: !!sameCaseGuid,
        cacheTime: 0,
        staleTime: 0,
    });
};
